module.exports = __webpack_public_path__ + "img/Angers-SCO.de3cb0cf.png";